/**
 * Nabvani S3 layout:
 *   .../Bhagvad Gita/PLAY-Adhyay 02/2-55.mp3
 *
 * Override with REACT_APP_GITA_AUDIO_BASE_URL if the bucket path changes
 * (no trailing slash; chapter folders are appended automatically).
 */
const DEFAULT_AUDIO_BASE =
  'https://nabvani.s3.eu-north-1.amazonaws.com/books/HINDI/General/Bhagvad%20Gita';

const AUDIO_BASE = (
  process.env.REACT_APP_GITA_AUDIO_BASE_URL || DEFAULT_AUDIO_BASE
).replace(/\/$/, '');

/**
 * Slokas confirmed uploaded so far. Expand this (or remove the check)
 * as more Adhyay folders go live on S3.
 */
const AVAILABLE_SLOKAS = new Set([
  '2-55',
  '2-56',
  '2-57',
  '2-58',
  '2-59',
  '2-60',
  '2-61',
  '2-62',
  '2-63',
  '2-64',
  '2-65',
  '2-66',
  '2-67',
  '2-68',
  '2-69',
  '2-70',
  '2-71',
  '2-72',
]);

export function isSlokaAudioAvailable(ref) {
  return AVAILABLE_SLOKAS.has(ref);
}

export function getSlokaAudioUrl(ref) {
  if (!ref || !isSlokaAudioAvailable(ref)) return null;

  const [chapter] = ref.split('-');
  const paddedChapter = String(chapter).padStart(2, '0');
  // Spaces in folder names must stay URL-encoded for <audio src>.
  return `${AUDIO_BASE}/PLAY-Adhyay%20${paddedChapter}/${ref}.mp3`;
}

export function hasAudioBaseConfigured() {
  return Boolean(AUDIO_BASE);
}
